import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {Widget} from 'Event/Widget/template'
import {useOrganization} from 'organization/OrganizationProvider'
import {useMutation, useQueryClient} from 'react-query'

export function useRegenerateWidgetToken() {
  const {event} = useEvent()
  const {client} = useOrganization()
  const qc = useQueryClient()

  return useMutation({
    mutationFn: () => {
      const url = api(`/events/${event.id}/widgets/regenerate_token`)
      return client.post<Widget>(url)
    },
    onSuccess: (updated) => {
      qc.setQueryData<Widget>(['events', event.id, 'widgets'], () => updated)
    },
  })
}
